var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hkld-header" },
    [
      _c(
        "a",
        {
          attrs: { id: "logo", disabled: !_vm.showLoggedInContent },
          on: { click: _vm.toHome },
        },
        [
          _vm.showLoggedInContent
            ? _c("img", {
                directives: [
                  {
                    name: "region-img-src",
                    rawName: "v-region-img-src",
                    value: "hkld-logo.png",
                    expression: "'hkld-logo.png'",
                  },
                ],
                staticClass: "hkld-logo",
                attrs: { alt: "Hongkong Land" },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.showLoggedInContent
            ? _c("img", {
                staticClass: "hkld-logo",
                attrs: { src: "/hkld-logo.png", alt: "Hongkong Land" },
              })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("NavBar"),
      _vm._v(" "),
      _c("SwitchLanguages"),
      _vm._v(" "),
      _vm.showLoggedInContent ? _c("SwitchRegions") : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showLoggedInContent,
              expression: "showLoggedInContent",
            },
          ],
          staticClass: "dropdown menu hamburger-box",
          attrs: {
            id: "dropdown-menu",
            "data-dropdown-menu": "",
            "data-disable-hover": "true",
            "data-click-open": "true",
          },
        },
        [
          _c("li", { staticClass: "dropdown-submenu-parent" }, [
            _c(
              "svg",
              {
                staticStyle: { cursor: "pointer" },
                attrs: { id: "hamburger", width: "66", height: "66" },
              },
              [
                _c("line", {
                  attrs: {
                    x1: "22",
                    x2: "44",
                    y1: "24",
                    y2: "24",
                    stroke: "white",
                    "stroke-width": "2",
                  },
                }),
                _vm._v(" "),
                _c("line", {
                  attrs: {
                    x1: "22",
                    x2: "44",
                    y1: "32",
                    y2: "32",
                    stroke: "white",
                    "stroke-width": "2",
                  },
                }),
                _vm._v(" "),
                _c("line", {
                  attrs: {
                    x1: "22",
                    x2: "44",
                    y1: "40",
                    y2: "40",
                    stroke: "white",
                    "stroke-width": "2",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "menu menu-content" },
              [
                _c("li", { staticClass: "list-item" }, [
                  _c("span", { staticClass: "user-hello" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.renderedHi) +
                        "\n            "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "user-name",
                        attrs: { id: "user_name" },
                        on: {
                          click: function ($event) {
                            return _vm.goToProfile()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.renderedName) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm._l(_vm.items, function (item, index) {
                  return [
                    _c(
                      "li",
                      {
                        key: index,
                        staticClass: "list-item",
                        staticStyle: { cursor: "pointer" },
                        on: {
                          click: function ($event) {
                            return _vm.goTo(item.target, item.params)
                          },
                        },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "hamburger-item",
                            attrs: { id: "hamburger" + index },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.title) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                }),
                _vm._v(" "),
                _c("li", { staticClass: "list-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "hamburger-item",
                      attrs: { id: "logout" },
                      on: {
                        click: function ($event) {
                          return _vm.logout()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("logout")) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
              ],
              2
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("confirm-continue", {
        ref: "hamburgerComfirm",
        staticStyle: { display: "block" },
      }),
      _vm._v(" "),
      _c("project-control-leave-modal"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }